module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview"
  }, [(_vm.currentFarm.dico.interview1) ? _c('div', {
    staticClass: "interview__line"
  }, [_c('div', {
    staticClass: "interview__title"
  }, [_vm._v(_vm._s(_vm.currentFarm.dico.interview_title))]), _c('div', {
    staticClass: "interview__content"
  }, [_c('div', {
    staticClass: "interview__col",
    domProps: {
      "innerHTML": _vm._s(_vm.currentFarm.dico.interview1)
    }
  }), _c('div', {
    staticClass: "interview__col",
    domProps: {
      "innerHTML": _vm._s(_vm.currentFarm.dico.interview2)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d79ba320", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d79ba320"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/interview/InterviewComponent.vue
// module id = 834
// module chunks = 0